{
  "staticPageWidgetSettings": "Configuración del widget de página estática",
  "addWidget": "Añadir widget",
  "editWidget": "Editar widget",
  "addTab": "Añadir pestaña",
  "editTab": "Editar pestaña",
  "ruleGroupError": "Por favor, complete todos los campos para las reglas.",
  "editCode": "Editar código",
  "copy": "Copiar configuración de la página",
  "archive": "Archivar",
  "paste": "Pegar configuración de la página",
  "pageTypeMismatch": "No coincide el tipo de página",
  "pageUpdated": "Página actualizada",
  "pageConfigIssues": "Página actualizada, pero con avisos",
  "characterLimit": "Límite de caracteres: 50",
  "goalWorkflowNotFound": "El flujo de trabajo de objetivos del widget {{widgetType}}, en la pestaña {{tab}}, no fue encontrado en esta organización, por lo que se eliminó de la configuración.",
  "householdWorkflowNotFound": "El flujo de trabajo del hogar del widget {{widgetType}}, en la pestaña {{tab}}, no fue encontrado en esta organización, por lo que se eliminó de la configuración.",
  "customFieldNotFound": "El campo personalizable {{customField}} del widget {{widgetType}}, en la pestaña {{tab}}, no fue encontrado en esta organización, por lo que se eliminó de la configuración.",
  "pasteWarning": "Al tratarse de una función beta, pegar configuraciones de página puede causar problemas. Utilícela con precaución y pruébela primero en un entorno seguro.",
  "addLinkTab": {
    "switch": "Habilitar enlace",
    "label": "Enlace externo",
    "error": "URL inválida"
  },
  "editPage": {
    "button": "Editar",
    "title": "Editar página",
    "options": {
      "greeting": "Saludo inicial",
      "enableAddingAccountToHousehold": "Habilitar la adición de cuentas desde y hacia un hogar",
      "enableAddingGoalToHousehold": "Habilitar la adición de objetivos desde y hacia un hogar",
      "addContent": "Añadir contenido",
      "showUpcomingMaintenanceSchedule": "Mostrar el próximo programa de mantenimiento",
      "contentDescriptionBanner": "Banner con descripción del contenido (máx. 50 caracteres)",
      "contentDescriptionBannerError": "La descripción debe tener menos de 50 caracteres",
      "contentDescriptionTitle": "Título de la descripción del contenido",
      "contentDescription": "Descripción del contenido",
      "deposit": "Depositar",
      "withdraw": "Retirar",
      "canEditHouseholdName": "Se puede editar el nombre del hogar",
      "enableClosingHousehold": "Habilitar el cierre de hogares",
      "canCloseGoal": "Habilitar el cierre de metas",
      "canCloseSubAccount": "Se puede cerrar la subcuenta",
      "canCloseAccount": "Habilitar el cierre de cuentas",
      "canForceOpenAccount": "Habilitar apertura forzada de cuenta",
      "canViewAccountStateHistory": "Ver historial del estado de la cuenta",
      "enableAccountEditing": "Habilitar edición de cuenta",
      "nickName": "Nombre de usuario",
      "repCode": "Código de representante",
      "state": "Estado de la cuenta",
      "custodianAccountNumber": "Número de cuenta",
      "dealerCode": "Código de distribuidor",
      "dealerName": "Nombre de distribuidor",
      "dealerAccountNumber": "Número de cuenta de distribuidor",
      "canTriggerWorkflows": "Se pueden activar los flujos de trabajo",
      "canChangeOrganization": "Se puede cambiar la organización",
      "canChangeHousehold": "Se puede cambiar el hogar",
      "removeFromHousehold": "Eliminar del hogar",
      "addToHousehold": "Agregar al hogar",
      "canFreezeClient": "Se puede congelar el cliente",
      "canDeactivateClient": "Se puede desactivar el cliente",
      "displayOrganizationName": "Mostrar nombre de la organización",
      "maxPageWidth": "Ancho máximo de la página",
      "enableSubAccountEditing": "Habilitar la edición de subcuentas",
      "goal": "Meta",
      "portfolioTheme": "Tema de la cartera",
      "modelPortfolio": "Cartera modelo",
      "tradingProcess": "Proceso de operación",
      "subAccountState": "Estado de subcuenta",
      "requireInvestorPolicyStatement": "Se requiere una declaración de política de inversión",
      "allowFractionalShares": "Permitir acciones fraccionadas",
      "allowClientDeposits": "Permitir depósitos de clientes",
      "subAccountLiquidated": "Subcuenta liquidada",
      "enableAccountGroupEditing": "Habilitar la edición de grupos de cuentas",
      "canDeleteAccountGroup": "Se puede eliminar el grupo de cuentas",
      "defaultDepositWorkflow": {
        "label": "-"
      },
      "canAddCurrency": "Habilitar la adición de una divisa",
      "enableHouseholdPortfolioMenuItems": "Mostrar los elementos del menú para adjuntar y desvincular la cartera del hogar"
    }
  },
  "widgetType": "Tipo",
  "add": "Añadir",
  "update": "Actualizar",
  "save": "Guardar",
  "hidden": "Oculto",
  "saveSuccessMessage": "Configuración de la página guardada",
  "saveStaticPageWidgetSuccessMessage": "Configuración del widget de página estática guardada",
  "label": "Etiqueta de la pestaña",
  "icon": "Ícono",
  "listOfIcons": "Lista de íconos",
  "deleteTab": "Eliminar pestaña",
  "viewFor": "Ver",
  "pageName": "Nombre de la página",
  "noReports": "No hay informes disponibles para el periodo seleccionado.",
  "selectViewFor": "Seleccione un cliente para obtener una vista previa de la configuración de esta página",
  "deposit": "Depositar",
  "withdraw": "Retirar",
  "options": "Opciones",
  "notEditableMessage": "Para realizar cambios, póngase en contacto con el servicio de asistencia.",
  "widgetTypes": {
    "CLIENT_NAME": "Nombre del cliente",
    "MARKET_VALUE_CHART": "Gráfico del valor de mercado",
    "ACCOUNTS": "Cuentas",
    "GOALS": "Metas",
    "GOALS_AND_ACCOUNTS": "Metas y cuentas",
    "SUB_ACCOUNTS": "Subcuentas",
    "HOLDINGS": "Activos",
    "DOCUMENTS": "Documentos",
    "LEDGER": "Libro mayor",
    "INITIATE_TRANSFER": "Iniciar transferencia",
    "SCHEDULED_TRANSFERS": "Transferencias programadas",
    "UPCOMING_TRANSACTIONS": "Próximas transacciones",
    "NON_INDIVIDUAL_INFORMATION": "Información no individual",
    "PERSONAL_INFORMATION": "Información personal",
    "RELATIONSHIP_INFORMATION": "Información de la relación",
    "EMPLOYMENT_INFORMATION": "Información laboral",
    "RESIDENCY_INFORMATION": "Información de residencia",
    "PERSONS_OF_INTEREST": "Personas de interés",
    "INCOME_ASSETS_AND_DEBTS": "Ingresos, activos y deudas",
    "SUITABILITY": "Idoneidad",
    "GOAL_SUITABILITY": "Idoneidad de meta",
    "ID_VERIFICATION": "Verificación de ID",
    "NEWS_AND_INSIGHTS": "Novedades e información",
    "RECENT_TRANSACTIONS": "Transacciones recientes",
    "EDIT_ACCOUNT": "Editar cuenta",
    "REFINITIV": "Refinitiv",
    "ACCESS": "Conceder acceso",
    "SEARCH_SECURITIES": "Buscar valores",
    "ADVISOR_CONTACT_INFORMATION": "Información de contacto del asesor",
    "PROJECTED_INCOME_REPORT": "Ingresos previstos",
    "NOTES": "Notas",
    "AUDIT_LOG": "Registro de auditoría",
    "TRADE_ORDERS": "Órdenes comeriales",
    "FEE_DETAILS": "Detalles de la tarifa",
    "HOUSE_HOLD_MEMBERS": "Miembros",
    "REVIEW_BANK_ACCOUNT_INFORMATION": "Revisar la información de la cuenta bancaria",
    "COMPLIANCE": "Cumplimiento",
    "PORTFOLIO": "Cartera",
    "HOUSEHOLD_MODEL_PORTFOLIO": "Cartera modelo del hogar",
    "TRANSFERS": "Transferencias",
    "RELATIONSHIPS": "Relaciones",
    "FREE_FORM_INPUT": "Entrada de forma libre",
    "RATE_OF_RETURNS": "Tasa de rentabilidad",
    "MODEL_PORTFOLIO_HOLDINGS": "Cartera modelo de inversiones",
    "BULK_TRADE_REQUESTS": "Solicitudes de comercio al por mayor",
    "GOAL_INFORMATION": "Información sobre la meta",
    "NEXT_BEST_ACTION": "Siguiente mejor acción (beta)",
    "CUSTOM_FIELDS_DISPLAY": "Visualización de campos personalizados",
    "MARKET_DATA_TICKER": "Ticker de datos del mercado",
    "NET_WORTH": "Patrimonio neto (beta)",
    "FEES_AND_REVENUE": "Tarifas e ingresos",
    "AUM_EXPLORER": "Explorador de activos bajo gestión facturables",
    "PRACTICE_OVERVIEW": "Descripción general de la práctica",
    "QUICK_LINKS": "Enlaces rápidos",
    "NETFLOWS": "Flujos netos",
    "OPEN_WORKFLOWS": "Abrir flujos de trabajo",
    "PENDING_TRANSACTIONS": "Transacciones pendientes",
    "REPORT": "Informe",
    "DATA_WIDGET": "Widget de datos",
    "CONFIGURABLE_TABLE_PAGE": "Página de tabla configurable",
    "CONFIGURABLE_TABLE_WIDGET": "Widget de tabla configurable",
    "ACCOUNT_GROUPS": "Grupos de Cuentas",
    "PRODUCT_AUM_EXPOSURE": "Exposición de Activos Bajo Gestión por Producto"
  },
  "refinitiv": {
    "securityDetails": "Detalles de seguridad",
    "newsHeadlines": "Titulares de noticias",
    "estimatesRatios": "Estimaciones y ratios",
    "fundAllocation": "Asignación de fondos",
    "fundAverageAnnualReturns": "Rendimientos anuales promedio del fondo",
    "priceYield": "Rendimiento del precio",
    "fundObjective": "Objetivo del Fondo"
  },
  "error": {
    "invalidIconErrorText": "Ingrese un valor snake_case, por ejemplo, \"saldo_de_cuenta\"",
    "maxLengthError": "Debe tener {{max}} caracteres o menos"
  },
  "editClient": {
    "changeOrganization": "Cambiar organización",
    "changeHousehold": "Cambiar hogar",
    "removeFromHousehold": "Eliminar del hogar",
    "activateClient": "Activar cliente",
    "freezeClient": "Congelar cliente",
    "deactivateClient": "Desactivar cliente",
    "copyID": "Copiar ID",
    "freezeClientModal": {
      "title": "Congelar cliente",
      "bodyText": "¿Confirma que desea congelar este cliente?"
    },
    "deactivateClientModal": {
      "title": "Desactivar cliente",
      "bodyText": "¿Confirma que desea desactivar este cliente?"
    },
    "reactivateClientModal": {
      "title": "Reactivar cliente",
      "bodyText": "¿Confirma que desea reactivar este cliente?"
    }
  },
  "editAccount": {
    "closeAccount": "Cerrar cuenta",
    "forceOpenAccount": "Forzar la apertura de cuenta",
    "viewStateHistory": "Ver historial de estado"
  },
  "htmlTemplate": {
    "languages": {
      "en": "Inglés",
      "fr": "Francés"
    }
  },
  "rateOfReturns": {
    "portfolio": "Cartera",
    "total": "Total",
    "groupOn": {
      "user": "Usuario",
      "household": "Hogar",
      "account": "Cuenta",
      "goal": "Meta",
      "subAccount": "Subcuenta",
      "accountGroup": "Grupo de cuentas"
    },
    "frequency": {
      "oneMonth": "1 mes",
      "threeMonth": "3 meses",
      "sixMonth": "6 meses",
      "oneYear": "1 año",
      "threeYear": "3 años",
      "fiveYear": "5 años",
      "yearToDate": "Acumulado hasta la fecha",
      "sinceInception": "Desde su creación"
    }
  },
  "nextBestAction": {
    "mainTitle": "Próximas acciones recomendadas",
    "title": "Genera las mejores acciones a seguir",
    "description": "Mediante el uso de la IA y el aprendizaje automático, podemos generar una lista de acciones que creemos que le ayudarán a atender mejor a sus clientes.",
    "generate": "Generar",
    "regenerate": "Regenerar",
    "disclaimerTitle": "Descargo de responsabilidad",
    "disclaimer": "Esta es una función beta y no está pensada para su uso en producción. No se garantiza que las acciones generadas sean precisas o completas."
  },
  "archivePageModal": {
    "title": "¿Confirma que desea archivar {{pageName}}?",
    "bodyText": "Esta configuración de página se archivará. ¿Desea continuar?"
  },
  "untitled": "Sin título",
  "feeWidgetOrgAccountGroupOnly": "Los detalles de la tarifa solo están disponibles para grupos de cuentas de la organización. Seleccione un grupo de cuentas de la organización para obtener una vista previa de este widget.",
  "addWorkflowTab": {
    "switch": "Habilitar flujo de trabajo",
    "label": "Flujo de trabajo",
    "none": "Ninguno"
  }
}
